import React, { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react';
import { IOrderFilters } from './useOrders';

export interface IFilterTag {
  key: string;
  value: string;
  filterName: string;
}

export interface IFilterCheckbox {
  key: string;
  value: boolean;
}

interface IFiltersContextData {
  filters: IOrderFilters;
  setFilters: Dispatch<SetStateAction<IOrderFilters>>;
  clearPagination: () => void;
  filterTags: IFilterTag[];
  setFilterTags: React.Dispatch<React.SetStateAction<IFilterTag[]>>;
  filterCheckboxes: IFilterCheckbox[];
  setFiltersCheckboxes: (filterCheckboxes: IFilterCheckbox[]) => void;
  currentSupplierId: number;
}
interface IFiltersProviderProps {
  children: ReactNode;
  filters: IOrderFilters;
  setFilters: Dispatch<SetStateAction<IOrderFilters>>;
  clearPagination: () => void;
  currentSupplierId: number;
}

export const FiltersContext = createContext({} as IFiltersContextData);

export const FiltersProvider = ({
  children,
  filters,
  setFilters,
  clearPagination,
  currentSupplierId
}: IFiltersProviderProps) => {
  const [filterCheckboxes, setFiltersCheckboxes] = useState([
    {
      key: 'Número do Pedido',
      value: false
    },
    {
      key: 'ID Produto',
      value: false
    },
    {
      key: 'Código Numérico',
      value: false
    },
    {
      key: 'Descrição do Produto',
      value: false
    }
  ]);

  const [filterTags, setFilterTags] = useState([
    {
      key: 'Número do Pedido',
      value: '',
      filterName: 'purchaseOrderId'
    },
    {
      key: 'ID Produto',
      value: '',
      filterName: 'productId'
    },
    {
      key: 'Código Numérico',
      value: '',
      filterName: 'numericCode'
    },
    {
      key: 'Nome do Produto',
      value: '',
      filterName: 'productName'
    },
    {
      key: 'Data de emissão',
      value: '',
      filterName: 'date'
    },
    {
      key: 'Filial',
      value: '',
      filterName: 'branchId'
    }
  ]);

  return (
    <FiltersContext.Provider
      value={{
        filters,
        setFilters,
        clearPagination,
        filterCheckboxes,
        setFiltersCheckboxes,
        filterTags,
        setFilterTags,
        currentSupplierId
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
